/////////////////////////////////////////
import 'utils/devSso/capture';
/////////

/**
 * app.js
 *
 * The entry index.html loads: ordered side-effect imports and polyfills. It stays JavaScript because TypeScript
 * rejects these side-effect imports. The app itself starts in startup/ (see docs/packages/web/architecture.md).
 */

import React from 'react';
import { createRoot } from 'react-dom/client';

import sanitizeCss from 'sanitize.css/sanitize.css?raw';
// ?inline, not ?raw: Vite rewrites the @font-face url()s to the hashed fonts under assets/.
import interCss from 'inter-ui/inter-variable.css?inline';

// What babel's corejs 3 entry expansion (core-js 3.0 features) adds for the oldest browsers that can parse the
// bundle (chrome>=85, edge>=85, firefox>=79, safari>=14, ios_saf>=14, samsung>=14, opera>=71). Newer built-ins such
// as Array.prototype.at were never polyfilled and still aren't.
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.regexp.flags';
import 'core-js/modules/es.typed-array.fill';
import 'core-js/modules/es.typed-array.set';
import 'core-js/modules/es.typed-array.sort';
import 'core-js/modules/web.immediate';

// make sure to initialize react core before importing any of our components (including other react components)
import 'utils/core';
import 'utils/interfaces';

import 'utils/tabAuthExchange'; // exchange auth session with other browser tabs

import { AppRoot } from 'startup/AppRoot';
import { initializeApp } from 'startup/initializeApp';
import { bugsnagNotifyRecoverable } from 'utils/core/bugsnag';

// <style>s, as style-loader added them: the runtime CSP (style-src-elem has no 'self') blocks a linked stylesheet in
// the documents that html2canvas (Report a problem) and MUI X print clone the page into.
document.head.append(
  Object.assign(document.createElement('style'), { textContent: sanitizeCss }),
  Object.assign(document.createElement('style'), { textContent: interCss }),
);

initializeApp();

const container = document.getElementById('app');
// React's default reports recovered render errors as uncaught window errors, which open the error page.
const root = createRoot(container, { onRecoverableError: bugsnagNotifyRecoverable });

root.render(<AppRoot />);
